// extracted by mini-css-extract-plugin
module.exports = {"styleUl":"Tooltip_styleUl__1We6r","extraClass":"Tooltip_extraClass__2qZ3K","Tooltip":"Tooltip_Tooltip__i8Xja"};